// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PaginationRightHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 9 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="9"
            height="15"
            fill="currentColor"
        >
            <path
                d="M880.764891,188.68136 L874.774687,182.203603 C874.591548,182.0065 874.5,181.753569 874.5,181.500425 C874.5,181.247367 874.59159,180.994137 874.774688,180.797248 L880.764892,174.319491 C881.146867,173.909304 881.782515,173.892045 882.18521,174.279538 C882.590753,174.668417 882.605069,175.318536 882.224454,175.725953 L876.849597,181.500532 L882.224454,187.275111 C882.605132,187.682614 882.590732,188.329877 882.18521,188.721526 C881.786282,189.107528 881.150006,189.090481 880.764892,188.68136 L880.764891,188.68136 Z"
                transform="matrix(-1 0 0 1 883 -174)"
            />
        </svg>
    );
};

export const paginationRightHoverString =
    "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjE1IiB2aWV3Qm94PSIwIDAgOSAxNSI+PHBhdGggZmlsbD0iI0UyMDAxQSIgZD0iTTg4MC43NjQ4OTEsMTg4LjY4MTM2IEw4NzQuNzc0Njg3LDE4Mi4yMDM2MDMgQzg3NC41OTE1NDgsMTgyLjAwNjUgODc0LjUsMTgxLjc1MzU2OSA4NzQuNSwxODEuNTAwNDI1IEM4NzQuNSwxODEuMjQ3MzY3IDg3NC41OTE1OSwxODAuOTk0MTM3IDg3NC43NzQ2ODgsMTgwLjc5NzI0OCBMODgwLjc2NDg5MiwxNzQuMzE5NDkxIEM4ODEuMTQ2ODY3LDE3My45MDkzMDQgODgxLjc4MjUxNSwxNzMuODkyMDQ1IDg4Mi4xODUyMSwxNzQuMjc5NTM4IEM4ODIuNTkwNzUzLDE3NC42Njg0MTcgODgyLjYwNTA2OSwxNzUuMzE4NTM2IDg4Mi4yMjQ0NTQsMTc1LjcyNTk1MyBMODc2Ljg0OTU5NywxODEuNTAwNTMyIEw4ODIuMjI0NDU0LDE4Ny4yNzUxMTEgQzg4Mi42MDUxMzIsMTg3LjY4MjYxNCA4ODIuNTkwNzMyLDE4OC4zMjk4NzcgODgyLjE4NTIxLDE4OC43MjE1MjYgQzg4MS43ODYyODIsMTg5LjEwNzUyOCA4ODEuMTUwMDA2LDE4OS4wOTA0ODEgODgwLjc2NDg5MiwxODguNjgxMzYgTDg4MC43NjQ4OTEsMTg4LjY4MTM2IFoiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDg4MyAtMTc0KSIvPjwvc3ZnPg==";

export default React.memo(PaginationRightHover);
